import LoginCallback from "@/pages/login/callback";
import SignUp from "@/pages/login/sign-up";
import LoginWrapper from "@/pages/login/wrapper";
import { useUserStore } from "../../../../common/store/src/user";
import { createBrowserRouter } from "react-router-dom";
import Recover from "@/pages/login/recover.tsx";
import BindWrapper from "@/pages/bind/wrapper.tsx";
import BindCallback from "@/pages/bind/callback.tsx";
import ErrorPage from "@/pages/error";
import { AuthLoader } from "@/router/loader.ts";

import * as Sentry from "@sentry/react";

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouter(createBrowserRouter);

export const router = sentryCreateBrowserRouter([
  {
    path: "/",
    loader: () => useUserStore.getState().refreshLoginStatus(true),
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        lazy: () => import("@/pages/discover"),
      },
      {
        path: "home",
        loader: AuthLoader,
        lazy: () => import("@/pages/home"),
      },
      {
        path: "test",
        lazy: () => import("@/pages/test"),
      },
      {
        path: "bind",
        loader: AuthLoader,
        element: <BindWrapper />,
        children: [
          {
            path: "callback",
            element: <BindCallback />,
          },
        ],
      },
      {
        path: "authorization",
        loader: AuthLoader,
        lazy: () => import("@/pages/authorization"),
      },
      {
        path: "login",
        element: <LoginWrapper />,
        children: [
          {
            index: true,
            path: "*",
            lazy: () => import("@/pages/login/general"),
          },
          {
            path: "code/*",
            lazy: () => import("@/pages/login/code"),
          },
          {
            path: "sign-up",
            element: <SignUp />,
          },
          {
            path: "recover",
            element: <Recover />,
          },
          {
            path: "callback",
            element: <LoginCallback />,
          },
        ],
      },
      {
        path: "kb",
        loader: AuthLoader,
        children: [
          {
            path: ":id",
            children: [
              {
                path: "",
                lazy: () => import("@/pages/knowledgeBase/Detail"),
              },
              {
                path: "wrong-list",
                lazy: () => import("@/pages/knowledgeBase/WrongList"),
              },
              {
                path: "favourite-list",
                lazy: () => import("@/pages/knowledgeBase/FavouriteList"),
              },
              {
                path: "chapter",
                lazy: () => import("@/pages/knowledgeBase/Chapter"),
              },
              {
                path: "rank",
                lazy: () => import("@/pages/knowledgeBase/Rank"),
              },
              {
                path: "plan",
                lazy: () => import("@/pages/knowledgeBase/Plan"),
              },
              {
                path: "search",
                lazy: () => import("@/pages/knowledgeBase/Search"),
              },
              {
                path: "q",
                children: [
                  {
                    path: ":qid",
                    lazy: () => import("@/pages/knowledgeBase/QuestionDetail"),
                  },
                ],
              },
              {
                path: "practice",
                children: [
                  {
                    path: "endless",
                    lazy: () => import("@/pages/practice/endless"),
                  },
                  {
                    path: "chapter",
                    lazy: () => import("@/pages/practice/endless"),
                  },
                  {
                    path: "single",
                    children: [
                      {
                        path: "make",
                        lazy: () => import("@/pages/practice/single/make"),
                      },
                      {
                        path: "room/:roomId",
                        lazy: () => import("@/pages/practice/single"),
                      },
                    ],
                  },
                ],
              },
              {
                path: "game",
                children: [
                  {
                    path: "match",
                    lazy: () => import("@/pages/game/match"),
                  },
                  {
                    path: "online/:roomId",
                    lazy: () => import("@/pages/game/online"),
                  },
                ],
              },
            ],
          },
          {
            path: "search",
            lazy: () => import("@/pages/kbsearch"),
          },
        ],
      },
      {
        path: "user-center",
        loader: AuthLoader,
        children: [
          {
            path: "",
            index: true,
            lazy: () => import("@/pages/userCenter"),
          },
          {
            path: "user",
            lazy: () => import("@/pages/userCenter/userSetting"),
          },
          {
            path: "bind/*",
            lazy: () => import("@/pages/userCenter/bind"),
          },
        ],
      },
    ],
  },
]);
